import { css } from '@emotion/react';
import { Footer } from '@sites/components/Footer';
import { Header } from '@sites/components/Header';
import { NotFoundSection } from '@sites/components/NotFoundSection';
import { HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '@sites/constants/layout';
import { useQueryParams } from '@sites/contexts/queryContext';

const NotFound = () => {
  const { isEmbed } = useQueryParams();
  return (
    <div
      css={(theme) =>
        css({
          position: 'relative',
          height: ['100vh', '100dvh'],
          overflow: 'hidden',
          display: 'grid',
          ...(!isEmbed && {
            gridTemplateRows: `${MOBILE_HEADER_HEIGHT}px 1fr`,
            [theme.mq.xl]: {
              gridTemplateRows: `${HEADER_HEIGHT}px 1fr`,
            },
          }),
        })
      }
      data-testid="not-found-page"
    >
      {!isEmbed && <Header isMobileAndSearchOpen={false} isNotFoundPage />}
      <div
        css={css({
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          position: 'relative',
          display: 'flex',
          flexFlow: 'column nowrap',
        })}
      >
        <div
          css={css({
            flexBasis: '100%',
          })}
        >
          <NotFoundSection />
        </div>
        {!isEmbed && <Footer />}
      </div>
    </div>
  );
};

NotFound.displayName = 'NotFound';

export default NotFound;
